<template>
    <timesheet-assessment-readiness
        v-if="api.showAssessmentReadiness"
        :ready="api.assessmentIsReady"
        :ready-count="api.assessmentReadyCount"
        :total-count="api.sortedLines.length"
        :issue-groups="api.assessmentIssueGroups"
        @open-first="api.openFirstIncompleteAssessment"
        @open-issue="api.openAssessmentIssue"
    ></timesheet-assessment-readiness>
</template>

<script>
import TimesheetAssessmentReadiness from './TimesheetAssessmentReadiness.vue';
export default {
    name: 'TimesheetAssessmentStatus',
    components: {TimesheetAssessmentReadiness},
    props: {api: {type: Object, required: true}}
};
</script>
